import { Helper } from '../../../../classes/helper'
import { cover } from '../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../context/montage.context'

export const AttachedBar = (): JSX.Element | null => {
  const { measure, roof } = useMontage()

  if (roof.attachment !== 'Wandmontage') return null

  return (
    <mesh
      position={[
        0,
        Helper.convertToMeter(measure.userHeight!),
        Helper.convertToMeter(cover.bar.depth / 2),
      ]}
      castShadow={cover.terraceCover.castShadow}
      receiveShadow={true}
    >
      <boxGeometry
        args={[
          Helper.convertToMeter(measure.userWidth!),
          Helper.convertToMeter(cover.bar.height),
          Helper.convertToMeter(cover.bar.depth),
        ]}
      />
      <meshPhysicalMaterial color={roof.userColor} />
    </mesh>
  )
}
